
import { classNames } from 'primereact/utils';
import React, { forwardRef, useContext, useImperativeHandle, useRef } from 'react';
import { Menu } from 'primereact/menu';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSignOut } from '../../auth/AuthService';
import { LayoutContext } from './layoutcontext';
import { Button } from 'primereact/button';

const AppTopbar = forwardRef((prod, ref) => {
    const { onMenuToggle, profileToggle, onProfileToggle } = useContext(LayoutContext);
    const {t, i18n} = useTranslation();
    const navigator = useNavigate();
    const menu = useRef(null);
    const menubuttonRef = useRef(null);
    const topbarmenuRef = useRef(null);
    const topbarmenubuttonRef = useRef(null);
    const signOut = useSignOut();
    const toggleMenu = (event) => {
        menu.current?.toggle(event);
    };

    const changeLang = (e) => {
        let val = e.currentTarget.value;
        val =  val == 1 ? 'kh' : 'en';
        i18n.changeLanguage(val ?? 'en')
    }

    const logoutFunction = () => {
        if (signOut()) {
            navigator('/login', {state: {logout: true}});
        }
    }

    const itemUser = [
        { 
            label: <span className="text-sm">{t('Preference')}</span>, 
            icon: 'pi pi-wrench' ,
            command: () => {
                navigator('/admin/user/edit');
            }
        },
        { 
            label: <span className="text-sm">{t('Data and information usage policy')}</span>, 
            icon: 'pi pi-info-circle',
            command: () => {
                navigator('/admin/disclaimer');
            }
        },
        { separator: true},
        { 
            label: <span className="text-sm">{t('Logout')}</span>, 
            icon: 'pi pi-sign-out',
            command: () => {
                logoutFunction()
            }
        },
    ];

    useImperativeHandle(ref, () => ({
        menubutton: menubuttonRef.current,
        topbarmenu: topbarmenuRef.current,
        topbarmenubutton: topbarmenubuttonRef.current
    }));

    return (
        <div className="layout-topbar">
            <Link href="/" className="layout-topbar-logo">
                <img src='/img/csx_logo.png' alt="logo" />
                <span>&nbsp;  ICSX</span>
            </Link>

            <button ref={menubuttonRef} type="button" className="p-link layout-menu-button layout-topbar-button" onClick={() => onMenuToggle()}>
                <i className="pi pi-bars" />
            </button>

            <button ref={topbarmenubuttonRef} type="button" className="p-link layout-topbar-menu-button layout-topbar-button" onClick={() => onProfileToggle()}>
                <i className="pi pi-ellipsis-v" />
            </button>

            <div ref={topbarmenuRef} className={ (profileToggle ? 'layout-topbar-menu-mobile-active' : ' ') + classNames(' layout-topbar-menu align-items-center')}>
                <Button className="bg-none hover:bg-bluegray-400 justify-content-center min-w-0 h-1rem px-1" alt="ភាសាខ្មែរ" value="1" onClick={changeLang}>
                    <img alt="logo" src="/img/flag/kh.png" className="h-1rem"></img>
                </Button>
                <Button className="bg-none hover:bg-bluegray-400 justify-content-center min-w-0 h-1rem px-1" value="2" onClick={changeLang}>
                    <img alt="logo" src="/img/flag/en.png" className="h-1rem"></img>
                </Button>
                <Menu ref={menu} model={itemUser} popup/>
                <button onClick={toggleMenu}
                    type="button" className="p-link layout-topbar-button">
                    <i className="pi pi-user"></i>
                </button>
            </div>
        </div>
    );
});

export default AppTopbar;
